import React, { useState } from 'react';
import styles from './SchemaExplorerFile.module.scss';
import HdIcon from '../../../../media/components/icon/HdIcon';
import useClipboardService from '../../../../clipboard/hooks/useClipboardService';
import { HdTooltip } from '../../../../tooltip/HdTooltip';
import { SchemaExplorerFileProps } from '../../interfaces/schemaExplorer';
import { getQuoteType } from '../../utils/schema-explorer-tree.helper';
import { HdKeyBadge } from '../../../../badge/components/key-badge/HdKeyBadge';

function SchemaExplorerFile({ file, source, schemaExplorerUIOptions }: SchemaExplorerFileProps) {
  const [fileNameFocused, setFileNameFocused] = useState(false);

  const clipboardService = useClipboardService();

  const getClipboardContent = (fileName: string) => {
    const { Dataset: datasetName } = source.display_config;
    const quoteType = getQuoteType(source.dest_type, datasetName);
    return `${quoteType}${fileName}${quoteType}`;
  };

  const copyToClipboard = (event, fileName) => {
    event.stopPropagation();
    clipboardService.copy(getClipboardContent(fileName), 'Field Name copied to clipboard');
  };

  return (
    <div className={`${styles.fileContainer} ${styles.wrapper}`}>
      <span className={styles.left}>
        {schemaExplorerUIOptions?.showFieldTypeIcon ? (
          <span className='datatype-icon mr-1'>
            <HdIcon name={file.dataTypeIcon} size={1} />
          </span>
        ) : null}

        <HdTooltip title={file.name} enableOnTextOverflow={!!fileNameFocused}>
          {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
          <span
            className={`${styles.fileName} ${file.searchHighlight ? styles.searchHighlight : ''}`}
            onMouseOver={() => setFileNameFocused(true)}
            onMouseOut={() => setFileNameFocused(false)}
          >
            {file.name}
          </span>
        </HdTooltip>

        {!schemaExplorerUIOptions?.showFieldTypeIcon ? (
          <HdTooltip title={file.dataType} enableOnTextOverflow>
            <span className={styles.fileType}>{file.dataType}</span>
          </HdTooltip>
        ) : null}

        <HdIcon
          name='copy'
          onClick={event => copyToClipboard(event, file.name)}
          className={styles.copySm}
          tabIndex={-1}
        />
      </span>

      {file.keys && file.keys.length ? (
        <HdKeyBadge className={styles.fileKeys} keys={file.keys} shrink />
      ) : null}
    </div>
  );
}

export default SchemaExplorerFile;
